module.exports = __webpack_public_path__ + "static/img/diamsauto_blanc.5ed3125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diamsauto_blanc.png
// module id = BNl/
// module chunks = 1